export default "__VITE_ASSET__DbdFSMjL__"